import React from "react";
import { Icon } from "@clarkinc/zest-design-system";
import spritePath from "~/common/Icons/Zest/remixicon.symbol.v1.svg";
import { sendSocialClickTrackingEvent } from "~/analytics/socialTracking";

interface SocialIconProps {
  name: string;
  link: string;
  ariaLabel: string;
}

const SocialIcon = ({ name, link, ariaLabel }: SocialIconProps) => {
  const onClick = () => {
    sendSocialClickTrackingEvent(link, ariaLabel, "Footer");
  };
  return (
    <a
      aria-label={ariaLabel}
      className="!flex p-0 justify-center items-center bg-green-600 w-8 h-8 rounded-full hover:bg-green-700 mr-5 last:mr-0"
      href={link}
      rel="noopener noreferrer"
      target="_blank"
      onClick={onClick}
    >
      <Icon
        className="fill-white"
        name={name}
        size="xsmall"
        spriteSheetHref={spritePath}
      />
    </a>
  );
};

export default SocialIcon;
